import { useEffect, useState } from 'react';
import FOOTER from 'components/footer';
import './style.css';
import api from 'services/api';
import { getcodCidade, getnome } from 'functions/gettabconfig';
import { useNavigate } from 'react-router-dom';
import config from 'config';
import CarrosselCampanhas from 'components/carrosselCampanha';
import CarrosselParticipantes from 'components/carrosselParticipantes';
import Conquistas from 'components/conquitas';
import CarrosselContemplados from 'components/carrosselContemplados';
import AvisoPopup from 'components/avisos';
import CarrosselNoticias from 'components/carrosselNoticias';
import HOMENAVEGACAO from 'components/navegacao';
import HEADER from 'components/header';
import CarrosselPromocoes from 'components/CarroselPromocoes';

function HOME() {

    const navigate = useNavigate();

    const [lcompanha, setLCampanha] = useState([]);
    const [lparticipante, setLParticipante] = useState([]);
    const [lcontemplado, setLContemplado] = useState([]);
    const [lnoticias, setLNoticias] = useState([]);
    const [lpromocoes, setlPromocoes] = useState([]);
    const [pnoticias, setPNotocias] = useState('N');
    const [ppromocoes, setPPromocoes] = useState('N');

    function Conquista() {
        navigate('/meu/conquista')
    }

    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    useEffect(() => {
        // Busca Parametros
        api.get(`${config.PARAMETROS}/NOTICIAS`)
            .then(response => {
                const valorNoticias = response.data['valor'];
                setPNotocias(valorNoticias);
                
                // Busca Noticias apenas se parametro = 'S'
                if (valorNoticias === 'S') {
                    api.get(`${config.NOTICIAS}?cod_cidade=${getcodCidade()}`)
                        .then(response => {
                            setLNoticias(response.data);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            })  
            .catch(error => {
                console.log(error);
            });

        api.get(`${config.PARAMETROS}/PROMOCOES`)
            .then(response => {
                const valorPromocoes = response.data['valor'];
                setPPromocoes(valorPromocoes);
                
                // Busca Promocoes apenas se parametro = 'S'
                if (valorPromocoes === 'S') {
                    api.get(`${config.PROMOCOES}?cod_cidade=${getcodCidade()}`)
                        .then(response => {
                            setlPromocoes(response.data);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            }) 
            .catch(error => {
                console.log(error);
            });           

        // Busca Campanhas
        api.get(`${config.CAMPANHAS}?cod_cidade=${getcodCidade()}`)
            .then(response => {
                setLCampanha(response.data);
            })
            .catch(error => {
                console.log(error);
            });
        // Busca Partificantes
        api.get(`${config.ESTABELECIMENTOS}?cod_cidade=${getcodCidade()}`)
            .then(response => {
                setLParticipante(shuffleArray(response.data));
            })
            .catch(error => {
                console.log(error);
            });
        // Busca Contemplados
        api.get(`${config.CONTEMPLADOS}?cod_cidade=${getcodCidade()}`)
            .then(response => {
                setLContemplado(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, [])

    return <>
    <HEADER/>
        <HOMENAVEGACAO />
        <div className="container-fluid">
            <Conquistas
                Conquista={Conquista}
                getnome={getnome()}
            />
            <CarrosselCampanhas
                lcompanha={lcompanha}
            />

            <CarrosselParticipantes
                lparticipante={lparticipante}
            />

            <CarrosselContemplados
                lcontemplado={lcontemplado} />

            {pnoticias==='S' &&  <CarrosselNoticias
                                    lnoticias={lnoticias}
                                />}
            {ppromocoes==='S' && <CarrosselPromocoes
                                   lpromocoes={lpromocoes}
                                />}
            <div className="mb-5"></div>
        </div>
        <FOOTER />
        <AvisoPopup />
    </>
}

export default HOME;